module.exports = __webpack_public_path__ + "img/3-7874.430e9a31.jpg";